// extracted by mini-css-extract-plugin
module.exports = {"club":"Club_club__aTeln","title_open":"Club_title_open__3Bp-Y","title_close":"Club_title_close__dl73K"};